var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpistrofes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "epistrofes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 48,
    viewBox: "0 0 65 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161551",
    "data-name": "Rectangle 161551",
    width: 40.518,
    height: 41.85,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_161553",
    "data-name": "Rectangle 161553",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 47,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_176054",
    "data-name": "Group 176054",
    transform: "translate(12.17 3.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176053",
    "data-name": "Group 176053",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38368",
    "data-name": "Path 38368",
    d: "M77.835,112.256a.961.961,0,0,0,.487.833l12.671,7.231c.023.013.049.018.073.03s.052.022.079.032a.871.871,0,0,0,.67,0c.027-.01.053-.02.079-.032s.049-.016.072-.03l12.672-7.231a.962.962,0,0,0,.487-.833V100.081c0-.026-.008-.051-.01-.077s-.006-.056-.011-.084a.948.948,0,0,0-.107-.316v0l0,0a.961.961,0,0,0-.222-.249c-.023-.019-.045-.037-.07-.054s-.039-.034-.062-.047L91.965,92.016a.981.981,0,0,0-.973,0L78.322,99.247c-.022.013-.039.032-.061.046s-.048.035-.071.054a.961.961,0,0,0-.222.249l0,0v0a.95.95,0,0,0-.107.316c0,.028-.009.055-.011.084s-.01.05-.01.077Zm1.946-10.509,10.724,6.121v9.953L79.781,111.7Zm5.363-4.171L95.868,103.7,91.479,106.2l-10.724-6.121Zm7.308,20.245v-9.953l5.841-3.334,0,0,4.881-2.786V111.7Zm-.973-23.86,10.725,6.12-4.389,2.5L87.09,96.465Z",
    transform: "translate(-71.813 -84.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38369",
    "data-name": "Path 38369",
    d: "M.942,11.1a.926.926,0,0,0,.074.22.915.915,0,0,0,.052.105.937.937,0,0,0,.146.177.96.96,0,0,0,.092.081.9.9,0,0,0,.1.083.915.915,0,0,0,.1.035.948.948,0,0,0,.113.037.942.942,0,0,0,.238.043c.012,0,.022.006.033.006a.918.918,0,0,0,.134-.009l6.649-.908a.962.962,0,1,0-.266-1.9l-4.528.618A19.38,19.38,0,0,1,28.973,4.459,18.888,18.888,0,0,1,36,30.4a19.3,19.3,0,0,1-26.148,7,.98.98,0,0,0-1.33.352.957.957,0,0,0,.356,1.314A21.042,21.042,0,0,0,19.338,41.85a21.374,21.374,0,0,0,5.55-.738,21.044,21.044,0,0,0,12.8-9.755A20.8,20.8,0,0,0,29.946,2.793,21.336,21.336,0,0,0,2.507,8.3l-.57-4.079A.966.966,0,0,0,.84,3.4.962.962,0,0,0,.01,4.488l.919,6.571c0,.015.011.027.014.042",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpistrofes);
export default __webpack_public_path__ + "static/media/epistrofes.96932969050db09825fb827b4fb74f3d.svg";
export { ForwardRef as ReactComponent };